import { SupabaseService } from "../../../server/supabase/base-supabase-service";

import type { UUID } from "../../../utils/uuid";

export class SupabaseDigitalAssetTagService extends SupabaseService<"digital_asset_tag"> {
  table = "digital_asset_tag" as const;

  async setAssetTags(asset_id: UUID, tag_ids: UUID[]) {
    return this.log_errors(
      this.client.rpc("set_asset_tags", { asset_id_: asset_id, tag_ids_: tag_ids }),
    );
  }

  async getAssetTags(account_id: UUID, asset_id: UUID) {
    const query = this.client.from(this.table).select("tag(*)").eq("asset_id", asset_id);

    return await this.getAllFromSelection(account_id, query, { order: [{ column: "tag_id" }] });
  }
}
